import React from 'react';
import { Helmet } from 'react-helmet';
import { useGeneratePageTitle } from 'hooks/useGeneratePageTitle';

interface PageTitleProps {
  title?: string;
  translatedTitle?: string;
  subTitle?: string;
}

const PageTitle = ({ title, translatedTitle, subTitle }: PageTitleProps) => {
  const { generatePageTitle } = useGeneratePageTitle();

  return (
    <Helmet>
      <title>{generatePageTitle(title, translatedTitle, subTitle)}</title>
    </Helmet>
  );
};

export default PageTitle;
